<div class="card">
  <div class="card-header">
    <h5 class="card-title">
      <!-- <i class="fas fa-users m2"></i -->
      Gestión de Usuarios
    </h5>
    <h6 class="card-subtitle text-muted">Administra los usuarios autorizados para usar el sistema</h6>
  </div>
  <div class="card-body">

    <!-- Acciones rápidas -->
    <div class="d-flex justify-content-around gap-2 mb-4">
      <button type="button" class="btn btn-primary" (click)="openAddUserModal()">
        <i class="fas fa-user-plus me-2"></i>
        Añadir Usuario
      </button>
      <button type="button" class="btn btn-primary" (click)="triggerFileUpload()">
        <i class="fas fa-file-upload me-2"></i>
        Cargar Fichero
      </button>
      <button type="button" class="btn btn-primary" (click)="downloadTemplate()">
        <i class="fas fa-download me-2"></i>
        Descargar Plantilla
      </button>
      <button type="button" class="btn btn-danger" (click)="deleteAllUsers()" [disabled]="users.length === 0">
        <i class="fas fa-trash-alt me-2"></i>
        Eliminar Todos
      </button>
      <input
        type="file"
        #fileInput
        class="d-none"
        accept=".xlsx,.xls,.csv"
        (change)="onFileSelected($event)">
    </div>

    <!-- Estadísticas -->
    <div class="stats-card-container mb-4">
      <div class="stat-card">
        <div class="stat-card__icon">
          <i class="fas fa-users"></i>
        </div>
        <div class="stat-card__info">
          <div class="stat-card__value">{{ users.length }}</div>
          <div class="stat-card__label">Total Usuarios</div>
        </div>
      </div>
      <div class="stat-card">
        <div class="stat-card__icon active">
          <i class="fas fa-user-check"></i>
        </div>
        <div class="stat-card__info">
          <div class="stat-card__value">{{ getActiveUsers() }}</div>
          <div class="stat-card__label">Usuarios Activos</div>
        </div>
      </div>
      <div class="stat-card">
        <div class="stat-card__icon inactive">
          <i class="fas fa-user-times"></i>
        </div>
        <div class="stat-card__info">
          <div class="stat-card__value">{{ getInactiveUsers() }}</div>
          <div class="stat-card__label">Usuarios Inactivos</div>
        </div>
      </div>
    </div>

    <!-- Buscador y filtros -->
    <div class="mb-3">
      <div class="input-group">
        <span class="input-group-text">
          <i class="fas fa-search"></i>
        </span>
        <input
          type="text"
          class="form-control"
          placeholder="Buscar por nombre"
          [(ngModel)]="searchTerm"
          (input)="filterUsers()">
      </div>
    </div>

    <!-- Tabla de usuarios -->
    <div class="table-responsive">
      <table class="table table-striped table-hover">
        <thead class="table-light">
          <tr>
            <!-- <th>ID</th> -->
            <th>Nombre</th>
            <th>Estado</th>
            <th>Tiempo de Uso</th>
            <th class="text-end">Acciones</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let user of filteredUsers" [class.inactive-row]="!user.active">
            <!-- <td><span class="badge bg-dark text-white">{{ user.id }}</span></td> -->
            <td>
              <div class="user-name">
                <strong>{{ user.name }}</strong>
              </div>
            </td>
            <td>
              <span class="badge" [class.bg-success]="user.active" [class.bg-secondary]="!user.active">
                {{ user.active ? 'Activo' : 'Inactivo' }}
              </span>
            </td>
            <td>
              <span class="usage-time">
                <i class="fas fa-clock me-1 text-muted"></i>
                {{ formatUsageTime(user.usageTime) }}
              </span>
            </td>
            <td class="text-end">
              <i class="fas fa-edit text-primary me-3"
                 (click)="editUser(user)"
                 title="Editar"
                 style="cursor: pointer; font-size: 1.1rem;"></i>
              <i class="fas me-3"
                 [class.fa-toggle-on]="user.active"
                 [class.fa-toggle-off]="!user.active"
                 [class.text-success]="user.active"
                 [class.text-warning]="!user.active"
                 (click)="toggleUserStatus(user)"
                 [title]="user.active ? 'Desactivar' : 'Activar'"
                 style="cursor: pointer; font-size: 1.1rem;"></i>
              <i class="fas fa-trash text-danger"
                 (click)="deleteUser(user)"
                 title="Eliminar"
                 style="cursor: pointer; font-size: 1.1rem;"></i>
            </td>
          </tr>
          <tr *ngIf="filteredUsers.length === 0">
            <td colspan="5" class="text-center py-4">
              <i class="fas fa-inbox fa-3x text-muted mb-3"></i>
              <p class="text-muted">No se encontraron usuarios</p>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Mensajes -->
    <div class="alert alert-success alert-dismissible mt-3" role="alert" *ngIf="successMessage">
      <i class="fas fa-check-circle me-2"></i>
      {{ successMessage }}
      <button type="button" class="btn-close" (click)="successMessage = ''"></button>
    </div>
    <div class="alert alert-danger alert-dismissible mt-3" role="alert" *ngIf="errorMessage">
      <i class="fas fa-exclamation-triangle me-2"></i>
      {{ errorMessage }}
      <button type="button" class="btn-close" (click)="errorMessage = ''"></button>
    </div>
  </div>
</div>

<!-- Modal para añadir/editar usuario -->
<app-modal-form-users
  *ngIf="showModal"
  [user]="currentUser"
  [editing]="editingUser"
  (close)="closeModal()"
  (save)="saveUser()">
</app-modal-form-users>
